import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { keys, type DocumentFilters } from "./keys";

async function fetchDocuments(filters: DocumentFilters, page: number, pageSize: number) {
  const from = page * pageSize;
  const to = from + pageSize - 1;

  let query = apiClient
    .from('documents')
    .select('*, providers:provider_id(name), document_types:document_type_id(id, name)', { count: 'exact' })
    .order('created_at', { ascending: false })
    .range(from, to);

  if (filters.subTopicId) {
    query = query.eq('sub_topic_id', filters.subTopicId);
  }

  if (filters.providerId) {
    query = query.eq('provider_id', filters.providerId);
  }

  const { data, error, count } = await query;

  if (error) {
    throw error;
  }

  return { data: data ?? [], count: count ?? 0 };
}

export function useGetDocuments(filters: DocumentFilters, page: number, pageSize: number) {
  const hasFilter = !!filters.subTopicId || !!filters.providerId;

  return useQuery({
    queryKey: keys.getDocuments(filters, page, pageSize),
    queryFn: () => fetchDocuments(filters, page, pageSize),
    enabled: hasFilter,
  });
}
